import React, {Component} from 'react'
import { connect } from 'react-redux'

// Actions
import { getContactInformation, saveContactInformation } from '../../../actions/settings'

// Components
import Phone from '../../../shared/components/Phone'

import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Text from '../../../shared/elements/text'
import LabelWrapper from '../../../shared/elements/labelWrapper'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

class Contact extends Component {

  constructor (props) {
    super(props)
    this.state = {
      // ShopId: 0,
      Mobile: '',
      PhoneCode: this.props.phonecode,
      Name: '',
      Mail: '',
      UserName: '',
      Password: '',
      Address: '',
      ZipCode: '',
      City: ''
    }
    this.updateContactInformation = this.updateContactInformation.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onPhoneChange = this.onPhoneChange.bind(this)
  }

  componentDidMount () {
    this.getContactInformation()
  }

  getContactInformation () {
    // this.props.auth.user.ShopId
    this.props.getContactInformation().then((res) => {
      this.setState({
        // ShopId: res.data.ShopId,
        Mobile: res.data.Mobile,
        PhoneCode: res.data.PhoneCode,
        Name: res.data.Name,
        Mail: res.data.Mail,
        UserName: res.data.UserName,
        Password: res.data.Password,
        Address: res.data.Address,
        ZipCode: res.data.ZipCode,
        City: res.data.City
      })
    }, () => {
      // console.log('get contact err', err)
    })
  }

  updateContactInformation () {
    this.props.saveContactInformation(this.state).then((res) => {
      // Toastr
      // window.toastr.success(translation('13462'), translation('13424'))
    }, (err) => {
      // Toastr
      if (err.response.data.DictionaryKey) {
        window.toastr.error(translation('13463') + '. ' + translation(err.response.data.DictionaryKey), translation('216'))
      } else {
        window.toastr.error(translation('13463'), translation('216'))
      }
    })
  }

  onChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  onPhoneChange (name, e) {
    let value = ''
    value = name.target.value
    if (name.target.name === 'PhoneNumber') {
      name = 'Mobile'
      this.setState({
        [name]: value
      })
    } else {
      this.setState({
        PhoneCode: {
          Id: Number(value.Id)
        }
      })
    }
  }

  render () {
    let canEditName = hasAccess([1, 2], this.props.auth.user.UserType)

    const renderLogin = () => {
      if (!hasSubscriptionPermission(this.props.auth, 10, 0)) return null
      return (
        <Panel title={translation('2223')} helpText={translation('2084') + ' ' + translation('1965') + ' ' + translation('1966')}>
          <Text name='UserName' value={this.state.UserName} onChange={this.onChange} onBlur={this.updateContactInformation} labelText={translation('1')} />
          <Text name='Password' value={this.state.Password} onChange={this.onChange} onBlur={this.updateContactInformation} labelText={translation('2')} />
        </Panel>
      )
    }

    return (
      <Row>
        <Col>
          <Panel title={translation('2222')} helpText={translation('2083')}>
            <Text name='Name' value={this.state.Name} onChange={this.onChange} onBlur={this.updateContactInformation} disabled={!canEditName} labelText={translation('30')} />

            <LabelWrapper labelText={translation('345')}>
              <Phone
                onChange={this.onPhoneChange}
                onBlur={this.updateContactInformation}
                code={this.state.PhoneCode}
                number={this.state.Mobile} />
            </LabelWrapper>

            <Text name='Mail' value={this.state.Mail} onChange={this.onChange} onBlur={this.updateContactInformation} labelText={translation('151')} />
            <Text name='Address' value={this.state.Address} onChange={this.onChange} onBlur={this.updateContactInformation} labelText={translation('25')} />
            <Text name='ZipCode' value={this.state.ZipCode} onChange={this.onChange} onBlur={this.updateContactInformation} labelText={translation('40')} />
            <Text name='City' value={this.state.City} onChange={this.onChange} onBlur={this.updateContactInformation} labelText={translation('37')} />
          </Panel>
        </Col>
        <Col>
          {renderLogin()}
        </Col>
      </Row>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    phonecode: state.common.phonecode,
    phonecodes: state.common.phonecodes
  }
}

export default connect(mapStateToProps, {
  getContactInformation,
  saveContactInformation
})(Contact)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Contact/index.js